import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {RoutesService} from '../../../core/routes/routes.service';
import {PlacesService} from '../../../core/places/places.service';
import {AccountsService} from '../../../core/accounts/accounts.service';
import {UtilsService} from '../../../core/utils/utils.service';

@Component({
  selector: 'app-point',
  templateUrl: './point.component.html',
  styleUrls: ['./point.component.scss']
})
export class PointComponent implements OnInit {

  @Input() point: any;
  @Output() change = new EventEmitter();

  constructor(private routesService: RoutesService,
              private placesService: PlacesService,
              private utilsService: UtilsService,
              private accountsService: AccountsService) { }

  ngOnInit() {
  }

  deletePoint(point) {
    this.routesService.deletePoint(point);
  }

  getAddress(point) {
    return point.place || point.account;
  }

  getLetter(point) {
    return this.routesService.getLetter(point);
  }

  getLegTravelTime(point) {
    return this.routesService.getLegTravelTime(point);
  }

  isLastPoint(point) {
    return this.routesService.isLastPoint(point);
  }

  openPoint(point) {
    if (point.place) {
      this.placesService.select(point.place.placeId);
    } else if (point.account) {
      this.accountsService.select(point.account);
    }
  }

  getTimeDifference(point) {
    const nextPoint = this.routesService.getNextPoint(point);
    if (!nextPoint) {
      return null;
    }
    return this.routesService.getTimeDifference(nextPoint);
  }

  getFormattedTimeDifference(point) {
    const nextPoint = this.routesService.getNextPoint(point);
    if (!nextPoint) {
      return null;
    }
    const difference = this.routesService.getTimeDifference(nextPoint);
    const timeStr = this.utilsService.getHrsMinFromMinutes(Math.abs(difference));
    return difference > 0 ? `${timeStr} early` : `${timeStr} late`;
  }


  setTime(time) {
    this.point.time = time;
    this.change.next();
  }

  setLength(length) {
    this.point.length = length;
    this.change.next();
  }

}



// WEBPACK FOOTER //
// ./client/app/components/routes/point/point.component.ts